import { atom } from "jotai";

export const timeAtom = atom(new Date());
